import { storage } from './firebase';


export const ref = (path) => {
    return storage.ref(path);
}